
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Line as LineChartGenerator } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import AnnotationPlugin from 'chartjs-plugin-annotation';
import ExpandedDashboardMixin from "@/views/expanded-dashboard/expanded-dashboard.mixin";
import AssessmentResult from "@/views/dashboard/assessment-result.vue";
import { setPhq9ChartOptions, getColor } from "@/views/expanded-dashboard/expanded-dashboard.utils";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler,
  ChartDataLabels,
  AnnotationPlugin
)

@Component({
  components: {
    LineChartGenerator,
    AssessmentResult
  }
})
export default class ExpandedPhq9 extends Mixins(ExpandedDashboardMixin) {
  @Prop() phq9ExpandedShow!: boolean;
  @Prop() pickDate!: Date;

  assessmentResultShow = false;
  assessmentType = "";
  assessmentDates = [];
  assessmentIds = [];
  assessmentValues = [];
  alertZones = [];
  loading = false;

  async mounted() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  }

  async fetchData() {
    const fetch = [
      this.$store.dispatch("ExpandedDashboard/fetchLabels", this.pickDate),
      this.$store.dispatch("ExpandedDashboard/fetchPhq9ChartOptions", this.selectedClientDDL.value),
      this.$store.dispatch("ExpandedDashboard/fetchPhq9ChartData", {
        participantId: this.selectedPatientSummary.participantId, 
        clientId: this.selectedClientDDL.value,
        timezone: this.selectedClient.timezone
      })
    ];
    await Promise.all(fetch);
    setPhq9ChartOptions(
      this.startDate, 
      this.labels.length, 
      this.phq9AlertZones,
      this,
      this.$store
    );
  }

  getPhq9Color(index: number) {
    return { color: getColor(index, this.phq9AlertZones, true) };
  }

  closeModal() {
    this.$emit('update:phq9ExpandedShow', false);
  }
}
